module.exports = __webpack_public_path__ + "img/KLN_background.fc0dc47f.png";